import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppSettingsService, ArrayResponse, BaseRestService, SendBackResult, serializeQueryString, encodeBase64 , saveAs} from '../../shared';
import {Order} from '../models/order';
import {OrderFilter} from '../models/order-filter';
import {Device} from '../../shared/models/device';
import {OrderListMultiAction, ValidationTicketMulti} from '../models/validation-ticket';
import {PickUpDhl} from '../models/pick-up-dhl';
import {OrderItem} from '../models/order-item';
import {SimpleObjectValue} from '../../shared/models/simple-object';


@Injectable({providedIn: 'root'})
export class OrdersService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'OrdersService'; }

  protected get isAnonymous(): boolean { return false; }

  getList(clientId: string, filter: OrderFilter): Observable<SendBackResult<ArrayResponse<OrderItem>>> {
    return this.get<ArrayResponse<OrderItem>>(`/Orders${serializeQueryString(filter)}`);
  }
  getAvailableDevice(productId: number): Observable<SendBackResult<ArrayResponse<Device>>> {
    return this.get<ArrayResponse<Device>>(`/Devices?productid=${productId}&available=true` );
  }
  getAvailableDeviceByClient(payload: {productID: number , client: string}): Observable<SendBackResult<ArrayResponse<Device>>> {
    return this.get<ArrayResponse<Device>>(`/Devices?productid=${payload.productID}&available=true&client=${payload.client}` );
  }
  getAvailableDeviceByClientAndByOrder(payload: {productID: number , client: string , order: string}): Observable<SendBackResult<ArrayResponse<Device>>> {
    return this.get<ArrayResponse<Device>>(`/Devices?productid=${payload.productID}&available=true&client=${payload.client}&order=${payload.order}` );
  }
  // tslint:disable-next-line:no-any
  addDevice(addDeviceObject: {orderUuid: string, deviceUuid: string , concepts: any}): Observable<SendBackResult<boolean>> {
    if (addDeviceObject.concepts) {
      return this.post<boolean>(`/Orders/${addDeviceObject.orderUuid}/add-device`, {'id': addDeviceObject.deviceUuid , concepts: addDeviceObject.concepts});
    } else {
      return this.post<boolean>(`/Orders/${addDeviceObject.orderUuid}/add-device`, {'id': addDeviceObject.deviceUuid});
    }


  }
  addAdoptionDevice(addDeviceObject: {
    orderUuid: string,
    code: string,
    family: string ,
    bsnProductModel: string ,
    concepts: string[] }): Observable<SendBackResult<boolean>> {
   if (addDeviceObject.family === 'brightsign') {
     return this.post<boolean>(`/Orders/${addDeviceObject.orderUuid}/AdoptDevice`,
       { 'family': addDeviceObject.family,
         'bsnProductModel': addDeviceObject.bsnProductModel ,
         'serialNumber' : addDeviceObject.code ,
         'concepts':  addDeviceObject.concepts });
   } else {
     return this.post<boolean>(`/Orders/${addDeviceObject.orderUuid}/AdoptDevice`,
       {'code': addDeviceObject.code , 'family': addDeviceObject.family , 'concepts':  addDeviceObject.concepts });
   }
  }
  addAdoptionSubscriptionDevice(addDeviceObject: {
    subscriptionUuid: string, code: string, family: string ,
    isDefault: boolean , bsnProductModel: string ,
    concepts: string[] }): Observable<SendBackResult<boolean>> {
    if (addDeviceObject.family === 'brightsign') {
      return this.post<boolean>(`/subscriptions/${addDeviceObject.subscriptionUuid}/adopt-device`,
        {'serialNumber': addDeviceObject.code ,
         'family': addDeviceObject.family ,
         isDefault: addDeviceObject.isDefault ,
         'bsnProductModel': addDeviceObject.bsnProductModel ,
         'concepts':  addDeviceObject.concepts});
    }
    return this.post<boolean>(`/subscriptions/${addDeviceObject.subscriptionUuid}/adopt-device`,
      {'code': addDeviceObject.code , 'family': addDeviceObject.family , isDefault: addDeviceObject.isDefault , 'concepts':  addDeviceObject.concepts});
  }
  addValidationTicket( ticket: ValidationTicketMulti): Observable<SendBackResult<ArrayResponse<SimpleObjectValue>>> {
    return this.post<ArrayResponse<SimpleObjectValue>>(`/orders/ValidationTicket`, ticket);
  }
  // tslint:disable-next-line:no-any
  getpdfazure(filepath: any): Observable<SendBackResult<ArrayResponse<string>>> {
    return  this.get<ArrayResponse<string>>(`/orders/getfilefromazure${serializeQueryString(filepath)}`);
  }

  // getpdfazureshipping(filepath: any): any {
  //   this.getpdfazure(filepath);
  //   this.getpdfazure(filepath).subscribe((data: any) => {
  //     if (data) {
  //     console.log(data);
  //     }
  //   });
  // }
  // saveAs(`data:text/csv;base64,${encodeBase64('sep=,\r\n' + response)}`, 'orders.csv')
  // tslint:disable-next-line:no-any
  createshipping( shipment: any): Observable<SendBackResult<ArrayResponse<SimpleObjectValue>>> {
    return this.post<ArrayResponse<SimpleObjectValue>>(`/Orders/Add-Automatic-tracking`, shipment);
  }
  // tslint:disable-next-line:no-any
  getRating( ratings: any): Observable<SendBackResult<ArrayResponse<SimpleObjectValue>>> {
    // tslint:disable-next-line:no-any
    return this.get<any>(`/Orders/dhlratings${serializeQueryString(ratings)}`);
  }

    // tslint:disable-next-line:no-any
  validateAddress( address: any): Observable<SendBackResult<ArrayResponse<SimpleObjectValue>>> {
      // tslint:disable-next-line:no-any
      return this.get<any>(`/Orders/validateAddress${serializeQueryString(address)}`);
    }
  // tslint:disable-next-line:no-any
  pushToSalesforce( data: any): Observable<SendBackResult<ArrayResponse<SimpleObjectValue>>> {
    return this.post<ArrayResponse<SimpleObjectValue>>(`/SalesforceJob/Orders`, data);
  }
  productionLineChange( productionLine: OrderListMultiAction): Observable<SendBackResult<ArrayResponse<SimpleObjectValue>>> {
    return this.post<ArrayResponse<SimpleObjectValue>>(`/Orders/Move-productionline`, productionLine);
  }
  addTracking(tracking: PickUpDhl): Observable<SendBackResult<ArrayResponse<SimpleObjectValue>>> {
    return this.post<ArrayResponse<SimpleObjectValue>>(`/Orders/add-tracking` ,
      {
     'orderUuids': tracking.orderUuid,
     'shipping' : {
       'trackingID': tracking.tracking.trackingID,
       'shipFromTrackingID': tracking.tracking.shipFromTrackingID,
       'transporterID': tracking.tracking.transporterID,
       'pickupDate' : tracking.tracking.departureDate
    }
  });
  }
  setOrderStatus(orderStatus: {uuid: string, status: string}): Observable<SendBackResult<Order>> {
    return this.post<Order>(`/orders/${orderStatus.uuid}/SetOrderStatus`, {value: orderStatus.status});
  }
  setForcedOrderStatus(orderStatus: {uuid: string, status: string}): Observable<SendBackResult<Order>> {
    return this.post<Order>(`/orders/${orderStatus.uuid}/SetOrderStatus?byPassValidation=true`, {value: orderStatus.status});
  }
  setTestCompleted(orderStatus: {uuid: string}): Observable<SendBackResult<Order>> {
    return this.post<Order>(`/orders/${orderStatus.uuid}/TestCompleted`, '');
  }
  SyncDataSFAction(orderStatus: {uuid: string}): Observable<SendBackResult<Order>> {
    return this.post<Order>(`/orders/${orderStatus.uuid}/SyncNetworkWithSalesForce`, '');
  }
  setInSetup(orderStatus: {uuid: string}): Observable<SendBackResult<Order>> {
    return this.post<Order>(`/orders/${orderStatus.uuid}/SetInSetup`, '');
  }

}
